export default {
  "root": "_root_1t3j3_1",
  "icon": "_icon_1t3j3_1",
  "dismiss": "_dismiss_1t3j3_1",
  "--highlighted": "_--highlighted_1t3j3_1",
  "--actionable": "_--actionable_1t3j3_1",
  "--variant-faded": "_--variant-faded_1t3j3_1",
  "--variant-outline": "_--variant-outline_1t3j3_1",
  "--color-positive": "_--color-positive_1t3j3_1",
  "--color-critical": "_--color-critical_1t3j3_1",
  "--color-warning": "_--color-warning_1t3j3_1",
  "--color-primary": "_--color-primary_1t3j3_1",
  "--size-small": "_--size-small_1t3j3_1",
  "--size-medium": "_--size-medium_1t3j3_1",
  "--size-large": "_--size-large_1t3j3_1",
  "--rounded": "_--rounded_1t3j3_1",
  "--hidden": "_--hidden_1t3j3_1",
  "container": "_container_1t3j3_1",
  "--container-overlap": "_--container-overlap_1t3j3_1",
  "--container-position-top-end": "_--container-position-top-end_1t3j3_1",
  "--container-position-bottom-end": "_--container-position-bottom-end_1t3j3_1"
};import "ni:sha-256;SrHk38JubBh8zkYiN8iFFA-JloBGqoyEi0aWHo_LmLo";